import React from 'react';
import { Navigate } from 'react-router-dom';

import { useShop } from '@services/ShopProvider';
import useChannelInfo from './useChannelInfo';

export const useTemplateRouting = (channel) => {
	const { shop } = useShop();
	const { channelId, channelDefinition, status } = useChannelInfo(channel);

	if (channelId === 'storefront') {
		return `/channels/${shop.id}/settings/storefront`;
	}

	if (!channelDefinition) {
		return `/channels/${shop.id}`;
	}

	if (status === 'enabled' || (status === 'pending' && !channelDefinition.comingSoon)) {
		return `/channels/${shop.id}/overview/${channelId}`;
	}
	return `/channels/${shop.id}/details/${channelId}`;
};

const TemplateRouter = () => {
	const url = useTemplateRouting();

	return <Navigate to={url} replace />;
};

export default TemplateRouter;
